<template>
    <div>
        <p v-for="(t, i) in value" :key="i" >
            昵称: {{t.nickname}}
        </p>
    </div>
</template>

<script>

export default {
    name: 'MessageWeChat.vue',
    props: {
        value: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data() {
        return {

        }
    },
    created(){

    },
    mounted(){
    },
    methods: {
        
    }
}
</script>

<style scoped>

</style>
